"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SGWTConnectNoop = void 0;
var SGWTConnectCore_1 = require("./SGWTConnectCore");
/**
 * Alternative implementation of SGWTConnectCore.
 *
 * This class should only be instantiated and used
 * when the user is on redirect_uri or in an iframe.
 * See explanation in setupSGWTConnect.ts
 */
var SGWTConnectNoop = /** @class */ (function (_super) {
    __extends(SGWTConnectNoop, _super);
    function SGWTConnectNoop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.requestAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.discardAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.renewAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.isAuthorized = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationError = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationHeader = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getGrantedScope = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.hasGrantedScope = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdToken = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdTokenClaims = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.enablePeriodicalRenewal = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.disablePeriodicalRenewal = function () {
        return this;
    };
    return SGWTConnectNoop;
}(SGWTConnectCore_1.SGWTConnectCore));
exports.SGWTConnectNoop = SGWTConnectNoop;
//# sourceMappingURL=SGWTConnectNoop.js.map